// extracted by mini-css-extract-plugin
export default {"wrapper":"X4-z","message":"Y4-z","image":"Z4-z"};